<template>
  <div v-html="markup">
  </div>
</template>

<script>

import OfferCounter from "./OfferCounter.vue";
import OfferDetailCounter from "./OfferDetailCounter.vue";
import Swiper from 'swiper';

import {Navigation, Pagination} from 'swiper/modules';

Swiper.use([Navigation]);
import config from '../../sublane-config';

import axios from 'redaxios/dist/redaxios';

export default {
  name: 'PollMarkup',
  data: () => {
    return {
      markup: ''
    }
  },
  components: {
    OfferCounter,
    OfferDetailCounter
  },
  computed: {},
  created() {
    this.fetchMarkup();
    if (parseInt(this.$attrs.interval) > 0)
      setInterval(() => this.fetchMarkup(), parseInt(this.$attrs.interval));
  },
  methods: {
    async fetchMarkup() {
      await axios.get(this.$attrs.uri)
          .then(response => {
            if (response.status === 200) {
              this.markup = response.data;
              this.$forceUpdate();
              setTimeout(function () {
                new Swiper('.tx-mediathek-sublane .swiper', config);
                console.log('🌞️ polled Sublane(s) initialized');
              }, 250);
            }
          })
          .catch(error => {
            console.log('🌞', error);
          });
    }
  }
}
</script>

<style lang="scss">
</style>